import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOpenInNew = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M11.5 2.75C11.5 2.34375 11.8125 2 12.25 2L17.2188 2C17.6562 2 17.9688 2.34375 17.9688 2.75V7.75C17.9688 8.1875 17.6562 8.5 17.2188 8.5C16.8125 8.5 16.4688 8.1875 16.4688 7.75V4.5625L9.5 11.5312C9.21875 11.8437 8.75 11.8437 8.46875 11.5312C8.15625 11.25 8.15625 10.7812 8.46875 10.4687L15.4375 3.5L12.25 3.5C11.8125 3.5 11.5 3.1875 11.5 2.75ZM4.25 3L8.25 3C8.65625 3 9 3.34375 9 3.75C9 4.1875 8.65625 4.5 8.25 4.5H4.25C3.8125 4.5 3.5 4.84375 3.5 5.25L3.5 15.75C3.5 16.1875 3.8125 16.5 4.25 16.5L14.75 16.5C15.1563 16.5 15.5 16.1875 15.5 15.75V11.75C15.5 11.3437 15.8125 11 16.25 11C16.6562 11 17 11.3437 17 11.75V15.75C17 17 15.9688 18 14.75 18L4.25 18C3 18 2 17 2 15.75L2 5.25C2 4.03125 3 3 4.25 3Z"
	})
});
const ForwardRef = forwardRef(SvgOpenInNew);
export default ForwardRef;
